<template>
  <div :class="{ disabled: disabled }" class="item-container">
    <div class="text-container">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "NetworkDiagramObjectMenuItem",
  props: {
    /**
     * Name of the button
     */
    label: {
      type: String
    },
    /**
     * Defines if the button is disabled or not.
     */
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.item-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 11px;
  background-color: white;
  width: 100px;
  height: 28px;
  cursor: pointer;
}

.item-container:hover {
  background: #f1f1f1;
}

.text-container {
  text-align: left;
  width: 80px;
}

.disabled {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Network/ObjectMenu/ObjectMenuItem.vue